import { formatMoneyHeatmap } from "helpers";
import { InteractionData } from "../../index";
import styles from "./tooltip.module.scss";

type TooltipProps = {
  interactionData: InteractionData | null;
  width: number;
  height: number;
};

export const Tooltip = ({ interactionData, width, height }: TooltipProps) => {
  if (!interactionData) {
    return null;
  }

  return (
    // Wrapper div: a rect on top of the viz area
    <div
      style={{
        width,
        height,
        position: "absolute",
        top: 0,
        left: 0,
        pointerEvents: "none",
      }}
    >
      {/* The actual box with dark background */}
      <div
        className={styles.tooltip}
        style={{
          position: "absolute",
          left: interactionData.xPos,
          top: interactionData.yPos,
        }}
      >
        <TooltipRow label={""} value={interactionData.yLabel} />
        <TooltipRow label={""} value={interactionData.xLabel} />
        <TooltipRow label={"Sales This Year"} value={formatMoneyHeatmap(interactionData.value)} />
      </div>
    </div>
  );
};

type TooltipRowProps = {
  label: string;
  value: string;
};

const TooltipRow = ({ label, value }: TooltipRowProps) => (
  <div>
    <b>{label}</b>
    {label? <span>: </span> : null}    
    <span>{value}</span>
  </div>
);
